// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../order-vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".automated-discount-notice[data-v-425d98e6]{margin-top:.75rem}", ""]);
// Exports
module.exports = exports;
